<template>
  <section class="pt-24">
    <div v-if="!state.isSubmitted">
      <span
        class="block text-gray-92 text-center font-light text-lg leading-8 py-4 mb-4"
        style="margin-top: 56px"
        >新しいパスワードを登録してください。</span
      >
      <div
        class="bg-white mx-auto mb-4 rounded-lg"
        style="max-width: 560px; padding: 32px 60px; margin-bottom: 288px"
      >
        <Form
          v-slot="{ handleSubmit, meta, errors }"
          :validation-schema="state.validationSchema"
          :validateOnMount="true"
          as="div"
        >
          <form @submit="handleSubmit($event, onSubmit)">
            <div style="margin-bottom: 36px">
              <div class="flex">
                <label
                  for="password"
                  class="inline-block text-gray-92 font-semibold leading-4 mb-3 required"
                  >パスワード</label
                >
                <span
                  class="ml-2 text-coral-main font-semibold"
                  style="font-size: 11px"
                  >必須</span
                >
                <div class="ml-auto text-xs text-gray-62">
                  半角英数8文字以上
                </div>
              </div>
              <Field
                :validateOnInput="true"
                as="input"
                type="password"
                name="password"
                id="password"
                class="block min-w-full px-4 py-3 border rounded leading-4"
                :class="{
                  'border-danger':
                    state.isDirty['password'] && errors && errors.password,
                }"
                v-model="state.password"
                @input="setIsDirty('password')"
                @blur="setIsDirty('password')"
              />
              <ErrorMessage
                v-if="state.isDirty['password']"
                name="password"
                as="span"
                class="text-danger leading-6"
              />
            </div>

            <div class="mb-12">
              <div class="flex">
                <label
                  for="passwordConfirm"
                  class="inline-block text-gray-92 font-semibold leading-4 mb-3 required"
                  >パスワード（確認）</label
                >
                <span
                  class="ml-2 text-coral-main font-semibold"
                  style="font-size: 11px"
                  >必須</span
                >
              </div>
              <Field
                :validateOnInput="true"
                as="input"
                type="password"
                name="passwordConfirm"
                id="passwordConfirm"
                class="block min-w-full px-4 py-3 border rounded leading-4"
                :class="{
                  'border-danger':
                    state.isDirty['passwordConfirm'] && errors.passwordConfirm,
                }"
                v-model="state.passwordConfirm"
                @input="setIsDirty('passwordConfirm')"
                @blur="setIsDirty('passwordConfirm')"
              />
              <ErrorMessage
                v-if="state.isDirty['passwordConfirm']"
                name="passwordConfirm"
                as="span"
                class="text-danger leading-6"
              />
            </div>

            <button
              type="submit"
              class="block mx-auto text-white font-semibold rounded hover:button focus:outline-none"
              :class="{
                'bg-secondary-main hover:button': meta.valid,
                'bg-slate-300': !meta.valid,
              }"
              style="width: 200px; height: 40px"
            >
              登録
            </button>
          </form>
        </Form>
      </div>
    </div>
    <div v-else class="text-center">
      <span
        class="block text-lg font-light text-gray-92 leading-8 py-4"
        style="margin: 56px auto 64px"
        >パスワード登録が完了しました。</span
      >
      <router-link
        :to="{ name: 'Login' }"
        class="block mx-auto bg-secondary-main text-white text-center leading-10 font-semibold rounded hover:button focus:outline-none"
        style="
          width: 200px;
          height: 40px;
          font-color: #fff;
          margin-bottom: 376px;
        "
        >ログインページへ</router-link
      >
    </div>
  </section>
</template>

<script>
import { reactive, inject } from 'vue';
import { useRouter } from 'vue-router';
import { Field, Form, ErrorMessage } from 'vee-validate';
import axios from '@/utils/axiosAuth.js';
import rules from '@/utils/validateRules.js';

export default {
  props: {},
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const router = useRouter();
    const globalMethods = inject('globalMethods');

    const state = reactive({
      isSubmitted: false,
      token: '',
      password: '',
      passwordConfirm: '',
      validationSchema: {
        password(value) {
          const result = rules.validate(
            value,
            'required|alpha_num_special|min:8'
          );
          return result === true ? true : result;
        },
        passwordConfirm(value) {
          const result = rules.validate(value, 'required');
          if (result !== true) {
            return result;
          }
          return value === state.password ? true : '入力内容が一致しません';
        },
      },
      isDirty: {},
    });
    (function checkToken() {
      if (router.currentRoute.value.params.token) {
        state.token = router.currentRoute.value.params.token;
      } else {
        router.push('/password/reset/request');
      }
    })();
    const onSubmit = async () => {
      const data = {
        token: state.token,
        password: state.password,
      };
      await axios
        .post('/users/password/reset', data)
        .then(() => {
          state.isSubmitted = true;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    const setIsDirty = (key) => {
      state.isDirty[key] = true;
    };

    return {
      state,
      setIsDirty,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped></style>
